/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Updatefailed1Inputs */

const zh_common_updatefailed1 = /** @type {(inputs: Common_Updatefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新失败`)
};

const en_common_updatefailed1 = /** @type {(inputs: Common_Updatefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update failed`)
};

const es_common_updatefailed1 = /** @type {(inputs: Common_Updatefailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al actualizar`)
};

/**
* | output |
* | --- |
* | "Update failed" |
*
* @param {Common_Updatefailed1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const common_updatefailed1 = /** @type {((inputs?: Common_Updatefailed1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Updatefailed1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_common_updatefailed1(inputs)
	if (locale === "en") return en_common_updatefailed1(inputs)
	return es_common_updatefailed1(inputs)
});
export { common_updatefailed1 as "common_updateFailed" }